export class CargoIntegrationInput {
    public name: string = '';
}
